export enum LocalStorageKeys {
  Decays = 'DECAYS-',
  Beta = 'BETA-',
  STABLE_BALANCE = 'STABLE_BALANCE-',
  PRODUCT_FORECAST = 'PRODUCT_FORECAST',
  MARKET_RATE_FORECAST = 'MARKET_RATE_FORECAST',
  PRODUCT_SETUP = 'PRODUCT_SETUP',
  ACQUISITION_SETUP = 'ACQUISITION_SETUP'
}
